import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
// import activities from '~/activities.json';
import Filter from '~/components/Search/Filter';
import SearchBox from '~/components/Search/SearchBox';
import Colors from '~/utils/colors';

const Container = styled.div`
  position: fixed;
  width: 100%;
  background-color: ${Colors.white};
  box-shadow: 0 -1px 8px 2px rgba(0, 0, 0, 0.2);
  z-index: 150;
  transition: bottom 0.3s;
  padding: 20px 20px 40px;
  box-sizing: border-box;
  bottom: ${props => (props.isShow ? 0 : -395)}px;
`;

const CloseBtn = styled.a`
  position: absolute;
  display: block;
  z-index: 160;
  width: 30px;
  height: 30px;
  top: 10px;
  right: 10px;
  > div {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    height: 2px;
    width: 25px;
    background-color: ${Colors.gray};
    &:nth-child(1) {
      transform: rotate(45deg);
    }
    &:nth-child(2) {
      transform: rotate(135deg);
    }
  }
`;

const ToggleFilterButton = styled.a`
  z-index: 100;
  display: block;
  position: fixed;
  border-radius: 3px;
  background-color: ${Colors.darkOrange};
  color: ${Colors.white};
  transition: opacity 0.3s;
  right: 0;
  left: 0;
  margin: 0 auto;
  font-weight: 500;
  bottom: 10px;
  width: 80px;
  padding: 10px 14px;
  box-shadow: 0 2px 4px 2px rgba(0, 0, 0, 0.3);
  transition: opacity 0.3s;
  ${props => {
    if (props.isShow) {
      return `
        visibility: visible;
        opacity: 1;
      `;
    }
    return `
      visibility: hidden;
      opacity: 0;
    `;
  }}
`;

const FilterIcon = styled.div`
  display: inline-block;
  width: 25px;
  margin-right: 5px;
  > div {
    height: 2px;
    background-color: ${Colors.white};
    margin: 2px auto;
    &:nth-child(1) {
      width: 18px;
      margin-top: 0;
    }
    &:nth-child(2) {
      width: 14px;
    }
    &:nth-child(3) {
      width: 8px;
      margin-bottom: 0;
    }
  }
`;

const FilterCount = styled.span`
  display: block;
  font-size: 11px;
  font-weight: 500;
  position: absolute;
  top: -5px;
  right: -5px;
  width: 20px;
  height: 20px;
  color: ${Colors.white};
  background-color: ${Colors.lightGray};
  text-align: center;
  border-radius: 50%;
`;

const MobileFilter = props => {
  const count = Object.keys(props.filterData).reduce((acc, curr) => {
    let plus = 0;
    if (props.filterData[curr]) {
      plus = 1;
      if (curr === 'price_from' || curr === 'price_to') {
        plus = 0.5;
      }
    }
    return acc + plus;
  }, 0);
  return (
    <div>
      <Container isShow={props.isOpenMobileFilter}>
        <CloseBtn
          className="close-btn"
          onClick={() => props.openMobileFilter(false)}
        >
          <div />
          <div />
        </CloseBtn>
        <Filter {...props} />
        <SearchBox {...props} />
      </Container>
      <ToggleFilterButton
        isShow={!props.isOpenMobileFilter}
        className="tmt-mobile-show"
        onClick={() => props.openMobileFilter()}
      >
        <FilterIcon>
          <div />
          <div />
          <div />
        </FilterIcon>
        <span>Filters</span>
        {count > 0 && <FilterCount className="count">{count}</FilterCount>}
      </ToggleFilterButton>
    </div>
  );
};

MobileFilter.propTypes = {
  isOpenMobileFilter: PropTypes.bool,
  filterData: PropTypes.object,
  openMobileFilter: PropTypes.func
};

export default MobileFilter;
